//PARTNER RESOURCES page component
//*******************************************************************
//*******************************************************************
//Importing Dependencies:
//external and package dependencies 
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//component dependencies
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import TextBlock from '../../components/textblock'
import ContentBlock from '../../components/ContentBlock'
import FullWidthImage from '../../components/FullWidthImage'
import Header from '../../components/Header'
import BodySectionAlt from '../../components/BodySectionAlt'
import ContentsTable from '../../components/ContentsTable'
import Helmet from "react-helmet"
//*******************************************************************
//******************************************************************* 
const partnerResourcesPage = ({data}) => {
    
    const partnerResources = data.partner_resources.edges    
    
    return (   
        
        <div>
        
            
             <Helmet>
                   <title>NJCCIC Partner Resources</title>
                    <meta name="description" content="Cyber security resources published by NJCCIC partners"/>
            </Helmet>
            <Heading/>
            
            <Navbar/>
        
            {partnerResources.map(({ node: {page_title, introductory_text, content_group, content_group_information_sharing, content_group_training_certification, content_group_additional_resources, headers, content_list, image} }) => (
        
                <div class="container-fluid">
        
                    <PageHeader divClass="containerWidth" elementClass="pageHeader centerText" title={page_title}/>
                                        
                    <div class="container containerWidth">
                        
                        <div class="row">
        
                            <TextBlock elementClass="standardText introPadding" text={introductory_text}/>   
                            
                        </div>
                    
                    </div>
        
                    <ContentsTable testClass="testClass container containerWidth grid2Container" elementClass="col-12 col-sm-6 col-md-4 grid2 blocks block2 block2Alt" dangerousClass="standardText blockText margin btnWidth" headerStyles="header contentTitle" data={content_group} iconId="iconsGroup"/>
                    
                    <FullWidthImage id="basicsBanner" src={image}/>
                    
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[0].section_name} id="information-sharing"/>
                    
                    <BodySectionAlt data={content_group_information_sharing}/>
                    
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[1].section_name} id="training-certification"/>
                    
                    <BodySectionAlt data={content_group_training_certification}/>
                    
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[2].section_name} id="additional-resources"/>
                    
                    <BodySectionAlt data={content_group_additional_resources}/>
                    
                </div>  
        
            ))}     
        
            <Footer/>       
            
        </div>  
    
    )    
    
}
//*******************************************************************
//*******************************************************************
export const query = graphql`
    query {
        partner_resources: allButterPage(filter: { slug: { eq: "partner-resources" } }) {
            edges {
                node {
                    seo_title
                    page_title
                    introductory_text
                    content_group {
                        section_name
                        icon 
                        text
                    }
                    content_list {
                        section_name
                        text
                    }
                    content_group_information_sharing {
                        icon 
                        section_name
                        preview_text
                        external_link
                    }
                    content_group_training_certification {
                        icon 
                        section_name
                        preview_text
                        external_link
                    }
                    content_group_additional_resources {
                        icon 
                        section_name
                        preview_text
                        external_link
                    }
                    image
                    headers {
                        section_name
                    }
                }               
            }
        }
    }
`
export default partnerResourcesPage       